import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { GroupApiService } from './group.api.service';
import { GroupEffects } from './group.effects';
import { groupReducer, groupInitialState, IGroupState } from './group.reducer';
import { GroupService } from './group.service';
import { groupFeatureKey } from './types';

@NgModule({
  imports: [
    StoreModule.forFeature<IGroupState>(groupFeatureKey, groupReducer, {
      initialState: groupInitialState,
    }),
    EffectsModule.forFeature([GroupEffects]),
  ],
  providers: [GroupApiService, GroupService],
})
export class StoreGroupModule {}
